module.exports = {
          srcSet: __webpack_public_path__ + "0a6bae97d598554e5c64160703838c0c-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "0a6bae97d598554e5c64160703838c0c-2336.png",width: 2336,height: 420}],
          src: __webpack_public_path__ + "0a6bae97d598554e5c64160703838c0c-2336.png",
          toString:function(){return __webpack_public_path__ + "0a6bae97d598554e5c64160703838c0c-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AE1Z9vxfavf/UF33/jxK9f8iM/f/Ljjl/l9Upf57bJL+YVeq/zM74PoAOEb1/D1L9v8wP/X+KTj1/yg49P8iMvb/PEXY/mlpsf4zP+P/IzLy+r2DMCqg1tTEAAAAAElFTkSuQmCC",
          width: 2336,
          height: 420
        }